function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import MiniSearch from 'minisearch';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import { filter, find, findIndex, includes, intersection } from 'lodash';
import DeleteIcon from 'svg/delete.svg';
import AddIcon from 'svg/add.svg';
import Loupe from 'svg/loupe-light.svg';
import Input from 'components/Form/Input';
import Table from 'components/Table';
import Tag from 'components/Tag';
import Button from 'components/Form/Button';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import Account from 'modules/Account';
import App from 'modules/App';
import { SCOPE_NAMES } from 'modules/Account/constants';
import messages from '../../../../../messages';
import * as constants from '../../../../../constants';
import * as actions from '../../../../../actions';
import * as selectors from '../../../../../selectors';
import styles from './IdentifierTermTable.pcss';
var _React_Component;
class IdentifierTermTable extends (_React_Component = React.Component) {
    static getDerivedStateFromProps(props, state) {
        const entities = get(props.formValues, 'values.terms', []);
        state.miniSearch.removeAll();
        state.miniSearch.addAll(entities);
        return state;
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.search !== this.state.search) {
            this.onSearchFinish();
        }
        if (this.props.updateOrAddIdentifierTerm && prevProps.updateOrAddIdentifierTerm !== this.props.updateOrAddIdentifierTerm) {
            this.onUpdateOrAddIdentifierTerm();
        }
    }
    onOpenAddOptionModal(term) {
        this.props.onSetIdentifierOptionFormValue(term);
        this.props.onOpenUpdateOrAddOptionModal();
    }
    onUpdateOrAddIdentifierTerm() {
        const { updateOrAddIdentifierTerm } = this.props;
        this.props.onCloseUpdateOrAddOptionModal();
        let terms = get(this.props.formValues, 'values.terms', []);
        const index = findIndex(terms, (term)=>term.termKey === updateOrAddIdentifierTerm.termKey);
        if (index !== -1) {
            terms[index] = updateOrAddIdentifierTerm;
        } else {
            terms = [
                ...terms,
                updateOrAddIdentifierTerm
            ];
        }
        this.props.onSetFormValue({
            id: 'terms',
            value: terms
        });
        this.props.onCloseUpdateOrAddOptionModal();
        this.props.onSetUpdateOrAddIdentifierTerm(null);
    }
    onClickDelete(termToDelete) {
        let terms = get(this.props.formValues, 'values.terms', []);
        terms = filter(terms, (term)=>term.termKey !== termToDelete.termKey);
        this.props.onSetFormValue({
            id: 'terms',
            value: terms
        });
    }
    onFilterTagClick(tag) {
        this.setState((state)=>{
            let { activeFilterTags } = state;
            activeFilterTags = find(activeFilterTags, (activeFilterTag)=>activeFilterTag === tag) ? filter(activeFilterTags, (activeFilterTag)=>activeFilterTag !== tag) : [
                ...activeFilterTags,
                tag
            ];
            return {
                activeFilterTags
            };
        });
    }
    onSearchFinish() {
        this.setState((state)=>({
                isSearchProcessing: state.isSearchProcessing
            }));
    }
    get entities() {
        let entities = get(this.props.formValues, 'values.terms', []);
        const { activeFilterTags, search } = this.state;
        if (search) {
            entities = this.state.miniSearch.search(search);
        }
        if (activeFilterTags.length) {
            entities = filter(entities, (entity)=>intersection(entity.identifierNames, activeFilterTags).length);
        }
        return entities;
    }
    get schema() {
        return [
            {
                key: 'termKey',
                labelMessage: messages.identifierTab.labels.termKey,
                renderer: (term)=>/*#__PURE__*/ _jsx("b", {
                        children: term.termKey
                    })
            },
            {
                key: 'labelValue',
                labelMessage: messages.identifierTab.labels.name,
                renderer: (term)=>/*#__PURE__*/ _jsx("p", {
                        children: term.labelValue
                    })
            },
            {
                key: 'personalIdentifier',
                labelMessage: messages.identifierTab.labels.personalIdentifier,
                renderer: (term)=>this.renderCheck(term, constants.IDENTIFIER_TERM_TYPES.PERSONAL)
            },
            {
                key: 'licence',
                labelMessage: messages.identifierTab.labels.licence,
                renderer: (term)=>this.renderCheck(term, constants.IDENTIFIER_TERM_TYPES.LICENCE)
            },
            {
                key: 'organizationIdentifier',
                labelMessage: messages.identifierTab.labels.organizationIdentifier,
                renderer: (term)=>this.renderCheck(term, constants.IDENTIFIER_TERM_TYPES.ORGANIZATION)
            },
            {
                key: 'actions',
                renderer: (term)=>this.renderActions(term)
            }
        ];
    }
    get filterTagsIds() {
        return [
            constants.IDENTIFIER_TERM_TYPES.PERSONAL,
            constants.IDENTIFIER_TERM_TYPES.LICENCE,
            constants.IDENTIFIER_TERM_TYPES.ORGANIZATION
        ];
    }
    renderCheck(term, termType) {
        return /*#__PURE__*/ _jsx(CheckboxRadio, {
            inputValue: "true",
            isDisabled: true,
            onChange: (input)=>this.props.onSetFormValue(input),
            value: includes(term.identifierNames, termType) ? 'true' : 'false'
        }, term.termKey);
    }
    renderActions(term) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "d-flex align-items-center justify-content-between",
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    labelMessage: messages.buttons.config,
                    className: "btn--outline mr-5",
                    type: "button",
                    onClick: ()=>this.onOpenAddOptionModal(term)
                }),
                /*#__PURE__*/ _jsx(DeleteIcon, {
                    className: styles.deleteIcon,
                    onClick: ()=>this.onClickDelete(term)
                })
            ]
        });
    }
    renderTable() {
        return /*#__PURE__*/ _jsx(Table, {
            idKey: "termKey",
            schema: this.schema,
            entities: this.entities,
            page: 0,
            perPage: 10,
            isPerPageOff: true
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    className: "text--h5 mt-0 mb-2",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.nationalIdentifiersRecords))
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph mb-7",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.nationalIdentifiersRecords))
                })
            ]
        });
    }
    renderTag(type) {
        return /*#__PURE__*/ _jsx(Tag, {
            id: type,
            titleMessage: messages.identifierTab.labels[type],
            isActive: !!find(this.state.activeFilterTags, (activeFilterTag)=>activeFilterTag === type),
            onClick: ()=>this.onFilterTagClick(type)
        }, type);
    }
    renderFilters() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.header,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.header_side, 'd-flex align-items-center'),
                    children: this.filterTagsIds.map((filterTagsId)=>this.renderTag(filterTagsId))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.header_side, 'd-flex align-items-center'),
                    children: [
                        this.renderSearch(),
                        this.renderAddNewTermButton()
                    ]
                })
            ]
        });
    }
    renderSearch() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.header__search,
            children: [
                /*#__PURE__*/ _jsx(Input, {
                    placeholder: messages.placeholders.searchIdentifier,
                    value: this.state.search,
                    onChange: (input)=>this.setState({
                            isSearchProcessing: true,
                            search: input.value
                        })
                }),
                /*#__PURE__*/ _jsx(Loupe, {
                    className: styles.search__loupe
                })
            ]
        });
    }
    renderAddNewTermButton() {
        return /*#__PURE__*/ _jsxs(Button, {
            type: "button",
            styleModifier: "primary",
            className: cn(styles.header__addNewTerm, 'btn--filled'),
            onClick: ()=>this.onOpenAddOptionModal(null),
            children: [
                /*#__PURE__*/ _jsx(AddIcon, {
                    className: styles.addButton__icon
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.buttons.addNew))
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "mt-7",
            children: [
                this.renderHeader(),
                this.renderFilters(),
                this.renderTable()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activeFilterTags: [],
            isSearchProcessing: false,
            miniSearch: new MiniSearch({
                idField: 'termKey',
                fields: [
                    'termKey',
                    'labelValue'
                ],
                storeFields: [
                    'termKey',
                    'labelValue',
                    'slaveRegExp',
                    'identifierNames'
                ],
                searchOptions: {
                    fuzzy: 0,
                    prefix: true
                }
            })
        };
    }
}
_define_property(IdentifierTermTable, "propTypes", {
    // Explicit props
    formValues: PropTypes.object.isRequired,
    onSetFormValue: PropTypes.func.isRequired,
    onSetIdentifierOptionFormValue: PropTypes.func.isRequired,
    onOpenUpdateOrAddOptionModal: PropTypes.func.isRequired,
    onCloseUpdateOrAddOptionModal: PropTypes.func.isRequired,
    onSetUpdateOrAddIdentifierTerm: PropTypes.func.isRequired,
    // Implicit props
    updateOrAddIdentifierTerm: PropTypes.object
});
const mapStateToProps = (state)=>({
        isSDNAdmin: Account.selectors.scope(state) === SCOPE_NAMES.SDN_ADMIN,
        updateOrAddIdentifierTerm: selectors.updateOrAddIdentifierTerm(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSetIdentifierOptionFormValue: (initialFormValue)=>dispatch(actions.setIdentifierOptionFormValue(initialFormValue)),
        onSetUpdateOrAddIdentifierTerm: (value)=>{
            dispatch(actions.setUpdateOrAddIdentifierTerm(value));
        },
        onOpenUpdateOrAddOptionModal: ()=>dispatch(App.actions.openModal(constants.ADD_IDENTIFIER_OPTION_MODAL)),
        onCloseUpdateOrAddOptionModal: ()=>dispatch(App.actions.closeModal(constants.ADD_IDENTIFIER_OPTION_MODAL))
    });
const ConnectedIdentifierTermTable = connect(mapStateToProps, mapDispatchToProps)(IdentifierTermTable);
export default withStyles(styles)(ConnectedIdentifierTermTable);
